import { render, staticRenderFns } from "./BlockPagingAnchor.vue?vue&type=template&id=e10a7742&scoped=true&"
import script from "./BlockPagingAnchor.vue?vue&type=script&scoped=true&lang=js&"
export * from "./BlockPagingAnchor.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./BlockPagingAnchor.vue?vue&type=style&index=0&id=e10a7742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10a7742",
  null
  
)

export default component.exports